import { INPUT_WIDTHS_EDITOR_CONDITION } from '../../constants/inlineLayout';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useConditionInputs } from '../../hooks/useConditionInputs';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useStrategy } from '../../hooks/useStrategy';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import EditorCondition from './EditorCondition';
import EditorConditionValueInput from './EditorConditionValueInput';
import EditorAssetAndPropertySelect from './EditorAssetAndPropertySelect';
import EditorIncludeObjectsWithNoValueSetInput from './EditorIncludeObjectsWithNoValueSetInput';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import { Select } from 'foundations-components/transitional/components/Select';
import { TypeaheadResultsItem } from 'foundations-components/transitional/components/Typeahead';
import UpdateFilterWithExternalOptionsNotification from '../operator/UpdateFilterWithExternalOptionsNotification';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { ENUMERATION, STRING } from 'customer-data-objects/property/PropertyTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NO_WRAP_PROPERTY_TYPES = [ENUMERATION, STRING];
const EditorConditionResponsive = ({
  condition,
  conditionPath,
  filterFamily,
  inputUse,
  isNested
}) => {
  var _condition$field;
  const {
    width
  } = useElementSize();
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionFieldChange,
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(filterFamily, conditionPath, condition);
  const {
    isIncludeObjectsWithNoValueSetCheckboxEnabled
  } = useStrategy();
  const {
    canFilterBeConverted,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  } = useConditionInputs({
    condition,
    filterFamily,
    onConditionOperatorChange: onFieldConditionOperatorChange,
    onConditionValueChange: onFieldConditionValueChange
  });
  if (!condition.field) {
    return null;
  }
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorCondition, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      inputUse: inputUse,
      isNested: isNested
    });
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    isNestedOrHeader: isNested,
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      hideChangeFieldButton: true,
      wrap: !NO_WRAP_PROPERTY_TYPES.includes((_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.type),
      onConditionDelete: () => onConditionDelete(conditionPath),
      deleteButtonLayoutStyle: "inline",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          width: `${INPUT_WIDTHS_EDITOR_CONDITION[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(EditorAssetAndPropertySelect, {
          field: condition.field,
          filterFamily: filterFamily,
          inputUse: inputUse,
          onChange: onFieldConditionFieldChange
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          flexShrink: 0,
          width: `${INPUT_WIDTHS_EDITOR_CONDITION[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(Select, {
          "data-onboarding": "filter-condition-select-field",
          "data-selenium-test": "fr-filter-operator-select",
          "data-test-id": "fr-filter-operator-select",
          disabled: isOperatorIncompatible,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(TypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          readOnly: operatorOptions.length === 1,
          value: condition.constructor.toString(),
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          minWidth: `${INPUT_WIDTHS_EDITOR_CONDITION[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
          condition: condition,
          filterFamily: filterFamily,
          inputUse: inputUse,
          onChange: onFieldConditionValueChange
        })
      })]
    }), isIncludeObjectsWithNoValueSetCheckboxEnabled && /*#__PURE__*/_jsx(EditorIncludeObjectsWithNoValueSetInput, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      onChange: onFieldConditionValueChange,
      spaceStyleProps: {
        marginBlockStart: '200'
      }
    }), isOperatorIncompatible && /*#__PURE__*/_jsx(UpdateFilterWithExternalOptionsNotification, {
      onUpdateClick: handleUpdateClick,
      canFilterBeConverted: canFilterBeConverted
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    })]
  });
};
export default EditorConditionResponsive;